var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolidWithRedAndDottedLines(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 136",
    width: 6,
    height: 136,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Solid wiith Red and Dotted Lines-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #c9edff } \n\t\t.s1 { fill: #c0eaff } \n\t\t.s2 { fill: #c4ebff } \n\t\t.s3 { fill: #fed1d1 } \n\t\t.s4 { fill: #c1eaff } \n\t\t.s5 { fill: #fecdcd } \n\t\t.s6 { fill: #fecece } \n\t\t.s7 { fill: #c8ecff } \n\t\t.s8 { fill: #c9ecff } \n\t\t.s9 { fill: #caedff } \n\t\t.s10 { fill: #cbedff } \n\t\t.s11 { fill: #cceeff } \n\t\t.s12 { fill: #ccedff } \n\t\t.s13 { fill: #d9f2ff } \n\t\t.s14 { fill: #c7ecff } \n\t\t.s15 { fill: #cbeeff } \n\t\t.s16 { fill: #c6ecff } \n\t\t.s17 { fill: #c5ebff } \n\t\t.s18 { fill: #c5ecff } \n\t\t.s19 { fill: #c3ebff } \n\t\t.s20 { fill: #c2ebff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-211.8 46.7c329.8 0 659.6 0 999.3 0q0 0.6 0 1.2c-329.8 0-659.5 0-999.3 0q0-0.6 0-1.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-212 505.5c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-212-45c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-211.8 92.6c329.8 0 659.6 0 999.3 0q0 0.5 0 1c-329.8 0-659.5 0-999.3 0q0-0.5 0-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-211.8 413.8c329.7 0 659.4 0 999.1 0q0 0.5 0 1c-329.7 0-659.4 0-999.1 0q0-0.5 0-1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m-211.5 459.8c329.6 0 659.2 0 998.8 0q0 0.5 0 1c-329.6 0-659.2 0-998.8 0q0-0.5 0-1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-211.5 367.9c329.6 0 659.2 0 998.8 0q0 0.5 0 1c-329.6 0-659.2 0-998.8 0q0-0.5 0-1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-211.5 322.2c329.6 0 659.2 0 998.8 0q0 0.5 0 1c-329.6 0-659.2 0-998.8 0q0-0.5 0-1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m-211.5 276.2c329.6 0 659.2 0 998.8 0q0 0.5 0 1c-329.6 0-659.2 0-998.8 0q0-0.5 0-1z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-211.5 230.3c329.6 0 659.2 0 998.8 0q0 0.4 0 0.9c-329.6 0-659.2 0-998.8 0q0-0.4 0-0.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m-211.5 184.5c329.6 0 659.2 0 998.8 0q0 0.5 0 1c-329.6 0-659.2 0-998.8 0q0-0.5 0-1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m-211.5 138.6c329.6 0 659.2 0 998.8 0q0 0.5 0 1c-329.6 0-659.2 0-998.8 0q0-0.5 0-1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m-211.5 1c329.6 0 659.2 0 998.8 0q0 0.5 0 1c-329.6 0-659.2 0-998.8 0q0-0.5 0-1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m749 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m726.3 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m703.5 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m696 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m688.5 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m673.3 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m665.8 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m643 482.5q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m574.8 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m552.1 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m544.6 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m537.1 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m514.3 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m506.8 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m484.1 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m461.3 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m438.6 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m415.8 482.5q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m393.1 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m385.6 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m362.9 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m355.4 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m347.9 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m325.1 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m302.4 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m279.6 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m256.9 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m234.1 482.5q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m226.6 482.5q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m203.9 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m196.4 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m188.9 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m173.7 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m166.2 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m150.9 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m75.2 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m52.4 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m44.9 482.5q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m37.4 482.5q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m14.7 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-8.1 482.5q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-30.8 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-83.8 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-106.5 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-114 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-136.8 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-144.3 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-167 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-189.8 482.5q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m749 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m726.3 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m688.5 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m665.8 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m567.3 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m544.6 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m529.6 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m506.8 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m484.1 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m431.1 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m408.3 344.9q2.3 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m385.6 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m370.6 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m347.9 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m325.1 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m302.4 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m272.1 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m249.4 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m226.6 344.9q2.3 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m188.9 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m166.2 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m90.4 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m67.7 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m44.9 344.9q2.3 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m14.7 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-8.1 344.9q2.3 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-68.5 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-91.3 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m-114 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-144.3 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-167 344.9q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m733.8 207.3q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m574.8 207.3q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m484.1 207.3q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m461.3 207.3q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m438.6 207.3q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m415.8 207.3q2.3 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m325.1 207.3q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m302.4 207.3q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m279.6 207.3q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m256.9 207.3q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m166.2 207.3q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m779.3 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m771.8 482.5q2 0 4.2 0 0.1 0.6 0.3 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m756.5 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.6-0.3-1.3z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m733.8 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m658.3 482.5q2.1 0 4.2 0 0.2 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m635.5 482.5q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m620.3 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m612.8 482.5q2.1 0 4.2 0 0.2 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m597.5 482.5q2.3 0 4.5 0 0 0.6 0 1.3-2 0-4.2 0-0.1-0.6-0.3-1.3z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m590 482.5q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m143.4 482.5q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m128.2 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m120.7 482.5q2.1 0 4.2 0 0.1 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m105.4 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.6-0.3-1.3z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m97.9 482.5q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m82.7 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m59.9 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.6-0.3-1.3z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-15.5 482.5q2 0 4.2 0 0.1 0.6 0.2 1.3-2.2 0-4.4 0 0-0.6 0-1.3z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-38.3 482.5q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m-53.5 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-61 482.5q2.1 0 4.2 0 0.1 0.6 0.3 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-76.3 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.6-0.3-1.3z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-99 482.5q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-174.5 482.5q2.1 0 4.2 0 0.2 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-197.3 482.5q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m771.8 344.9q2 0 4.2 0 0.1 0.6 0.3 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m703.8 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m696.3 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m681 344.9q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m673.5 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m658.3 344.9q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m635.5 344.9q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m612.8 344.9q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m590 344.9q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m575.1 344.9q2 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m552.3 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m514.6 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m461.6 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m438.8 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m416.1 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m393.3 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m363.1 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m355.6 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m279.9 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m257.1 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m234.4 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m204.1 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m196.6 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m173.9 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m143.4 344.9q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m75.4 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m52.7 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m37.4 344.9q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-15.5 344.9q2 0 4.2 0 0.1 0.6 0.2 1.2-2.2 0-4.4 0 0-0.6 0-1.2z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-83.5 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m-106.3 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-136.5 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-174.5 344.9q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-197.3 344.9q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m726.3 207.3q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m703.8 207.3q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m696 207.3q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m673.5 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m537.1 207.3q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m514.6 207.3q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m385.6 207.3q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m363.1 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m355.6 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m226.6 207.3q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m204.1 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m196.4 207.3q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m173.9 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m143.4 207.3q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m120.7 207.3q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m97.9 207.3q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m75.2 207.3q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "s15",
    d: "m37.4 207.3q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-15.5 207.3q2 0 4.2 0 0.1 0.6 0.2 1.2-2.2 0-4.4 0 0-0.6 0-1.2z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-38.3 207.3q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m-61 207.3q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-83.8 207.3q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-114 207.3q2.1 0 4.2 0 0.1 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-136.5 207.3q2.1 0 4.2 0 0 0.6 0 1.2-2.2 0-4.5 0 0.2-0.6 0.3-1.2z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-174.5 207.3q2.1 0 4.2 0 0.2 0.6 0.3 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-197.3 207.3q2.1 0 4.3 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m644.2 344.9q0.6 0 1.2 0 0.3 0 0.6 0 0.8 0 1.5 0 0 0.6 0 1.2-2.1 0-4.2 0-0.1-0.4-0.3-1c0.3-0.2 0.3-0.2 1.2-0.2z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m537.3 344.9q2 0 4 0 0.1 0.6 0.3 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m152.1 344.9q0.6 0 1.2 0 0.3 0 0.6 0 0.8 0 1.5 0 0 0.6 0 1.2-2.1 0-4.2 0-0.2-0.4-0.3-1c0.3-0.2 0.3-0.2 1.2-0.2z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m120.9 344.9q2 0 4 0 0.1 0.6 0.3 1.2-2.2 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m98.2 344.9q1.9 0 4 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-29.6 344.9q0.6 0 1.2 0 0.3 0 0.6 0 0.8 0 1.5 0 0 0.6 0 1.2-2.1 0-4.2 0-0.2-0.4-0.3-1c0.3-0.2 0.3-0.2 1.2-0.2z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-38 344.9q1.9 0 4 0 0.1 0.6 0.2 1.2-2.2 0-4.5 0 0.1-0.6 0.3-1.2z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-60.8 344.9q2 0 4 0 0.1 0.6 0.3 1.2-2.3 0-4.5 0 0.1-0.6 0.2-1.2z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-188.6 344.9q0.6 0 1.2 0 0.3 0 0.6 0 0.8 0 1.5 0 0 0.6 0 1.2-2 0-4.2 0-0.1-0.4-0.3-1c0.3-0.2 0.3-0.2 1.2-0.2z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m764.3 482.5q2 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m741.5 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m718.8 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m711.3 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m681 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m650.8 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m628 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m605.3 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2 0-4.2 0 0-0.6 0-1.3z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m582.6 482.5q2 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m567.3 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m559.8 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m529.6 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m522.1 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m499.3 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m491.8 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m476.6 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m469.1 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m453.8 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m446.3 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m431.1 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m423.6 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m408.3 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m400.8 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m378.1 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m370.6 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m340.4 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m332.9 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m317.6 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m310.1 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m294.9 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m287.4 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m272.1 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m264.6 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m249.4 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m241.9 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m219.1 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m211.6 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m181.4 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m158.7 482.5q2 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m135.9 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m113.2 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m90.4 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m67.7 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m29.9 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m22.4 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m7.2 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2 0-4.2 0 0-0.6 0-1.3z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m-0.3 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2 0-4.2 0 0-0.6 0-1.3z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m-23 482.5q2 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m-45.8 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m-68.5 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m-91.3 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m-121.5 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-129 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m-151.8 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m-159.3 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m-182 482.5q2.1 0 4.2 0 0 0.6 0 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m-204.8 482.5q2.1 0 4.3 0 0 0.6 0 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m779.5 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m764.3 344.9q2 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m756.8 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m741.5 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m734 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m718.8 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m711.3 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m650.8 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m628 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m620.5 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m605.3 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m597.8 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m582.6 344.9q2 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m559.8 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m522.1 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m499.3 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m491.8 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m476.6 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m469.1 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m453.8 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m446.3 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m423.6 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m400.8 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m340.4 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m332.9 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m317.6 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m310.1 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m294.9 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m287.4 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m264.6 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m241.9 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m219.1 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m211.6 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m181.4 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m158.7 344.9q2 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m135.9 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m128.4 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m113.2 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m105.7 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m82.9 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m60.2 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m29.9 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m22.4 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m7.2 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-0.3 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-23 344.9q2 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-45.8 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-53.3 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-76 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-98.8 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-121.5 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-129 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-151.8 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-159.3 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-182 344.9q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-204.8 344.9q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m718.8 207.3q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m711.3 207.3q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m681 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m567.3 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m559.8 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m529.6 207.3q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m522.1 207.3q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m400.8 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m378.1 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m370.6 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m340.4 207.3q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m219.1 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m211.6 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m181.4 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m67.7 207.3q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m29.9 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m22.4 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m7.2 207.3q2.1 0 4.2 0 0 0.6 0 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-121.5 207.3q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-129 207.3q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-151.8 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m-159.3 207.3q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m378.4 344.9q1.9 0 4 0 0 0.6 0 1.2-2.1 0-4.3 0 0.1-0.6 0.3-1.2z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-211.8 482.5q1.9 0 3.8 0 0 0.6 0 1.3-1.7 0-3.5 0-0.1-0.6-0.3-1.3z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m771.8 207.5q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m749 207.5q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m658.3 207.5q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m635.5 207.5q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m612.8 207.5q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m590 207.5q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m544.6 207.5q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m44.9 207.5q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m771.8 69.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.4 0-1z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m749 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m726.3 69.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.4 0-1z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m703.5 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m696 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m688.5 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m665.8 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m658.3 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m643 69.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m635.5 69.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m612.8 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m590 69.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m574.8 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m552.1 69.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.4 0-1z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m544.6 69.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.4 0-1z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m537.1 69.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.4 0-1z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m506.8 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m484.1 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m461.3 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m438.6 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m415.8 69.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m393.1 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m362.9 69.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.4 0-1z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m347.9 69.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.4 0-1z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m325.1 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m302.4 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m279.6 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m256.9 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m234.1 69.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m203.9 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m196.4 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m188.9 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m166.2 69.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.4 0-1z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m150.9 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m143.4 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m120.7 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m97.9 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m75.2 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m52.4 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m44.9 69.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m37.4 69.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m14.7 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-8.1 69.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-15.5 69.6q2.2 0 4.4 0 0 0.5 0 1-2.2 0-4.4 0 0-0.4 0-1z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-30.8 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-38.3 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-61 69.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.4 0-1z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-83.8 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-106.5 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m-136.8 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-144.3 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-167 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-174.5 69.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-189.8 69.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-197.3 69.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.4 0-1z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-211.5 344.9q1.7 0 3.5 0 0 0.6 0 1.2-1.7 0-3.5 0 0-0.6 0-1.2z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m779.5 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m764.3 207.5q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m756.8 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m741.5 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m666 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m650.8 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m643.3 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m628 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m620.5 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m605.3 207.5q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m597.8 207.5q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m582.6 207.5q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m552.3 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m506.8 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m499.3 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m491.8 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m476.6 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m469.1 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m453.8 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m446.3 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m431.1 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m423.6 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m408.3 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m393.3 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m347.9 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m332.9 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m317.6 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m310.1 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m294.9 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m287.4 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m272.1 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m264.6 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m249.4 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m241.9 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m234.4 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m188.9 207.5q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m158.7 207.5q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m151.2 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m135.9 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m128.4 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m113.2 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m105.7 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m90.4 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m82.9 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m60.2 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m52.7 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m14.9 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-0.3 207.5q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-7.8 207.5q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-23 207.5q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-30.5 207.5q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-45.8 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-53.3 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-68.5 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-76 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-91.3 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-98.8 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-106.3 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-144 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-166.8 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-182 207.5q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-189.5 207.5q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-204.8 207.5q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m779.5 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m764.3 69.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m756.8 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m741.5 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m734 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m718.8 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m711.3 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m681 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m673.5 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m650.8 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m628 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m620.5 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m605.3 69.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m597.8 69.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m582.6 69.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m567.3 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m559.8 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m529.6 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m522.1 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m514.6 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m499.3 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m491.8 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m476.6 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m469.1 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m453.8 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m446.3 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m431.1 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m423.6 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m408.3 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m400.8 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m385.6 69.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m378.1 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m370.6 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m355.6 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m340.4 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m332.9 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m317.6 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m310.1 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m294.9 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m287.4 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m272.1 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m264.6 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m249.4 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m241.9 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m226.6 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m219.1 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m211.6 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m181.4 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m173.9 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m158.7 69.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m135.9 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m128.4 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m113.2 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m105.7 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m90.4 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m82.9 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m67.7 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m60.2 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m29.9 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m22.4 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m7.2 69.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-0.3 69.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.4 0-1z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-23 69.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-45.8 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-53.3 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-68.5 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-76 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-91.3 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-98.8 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-114 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-121.5 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-129 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-151.8 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-159.3 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-182 69.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.4 0-1z"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-204.8 69.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.4 0-1z"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m688.8 207.5q1.9 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-211.5 207.5q1.7 0 3.5 0 0 0.5 0 1-1.7 0-3.5 0 0-0.5 0-1z"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-211.5 69.6q1.7 0 3.5 0 0 0.5 0 1-1.7 0-3.5 0 0-0.4 0-1z"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m734.3 207.5q1.8 0 3.7 0 0 0.4 0 0.8-1.8 0-3.7 0 0-0.4 0-0.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidWithRedAndDottedLines);
export default __webpack_public_path__ + "static/media/Solid-with-Red-and-Dotted-Lines.11e4887ec535ec34d50fda1845bd3743.svg";
export { ForwardRef as ReactComponent };